/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const startMultipartUpload = /* GraphQL */ `
  mutation StartMultipartUpload($input: StartMultipartUploadInput!) {
    startMultipartUpload(input: $input) {
      fileKey
      uploadId
      chunkNumber
      chunkSize
      __typename
    }
  }
`;
export const completeMultipartUpload = /* GraphQL */ `
  mutation CompleteMultipartUpload($input: CompleteMultipartUploadInput!) {
    completeMultipartUpload(input: $input)
  }
`;
export const deleteFile = /* GraphQL */ `
  mutation DeleteFile($input: DeleteFileInput!) {
    deleteFile(input: $input)
  }
`;
export const createFolder = /* GraphQL */ `
  mutation CreateFolder($input: CreateFolderInput!) {
    createFolder(input: $input)
  }
`;
export const uploadReferenceLine = /* GraphQL */ `
  mutation UploadReferenceLine($input: UploadReferenceLineInput!) {
    uploadReferenceLine(input: $input)
  }
`;
export const createDownloadZipFilePath = /* GraphQL */ `
  mutation CreateDownloadZipFilePath($input: CreateDownloadZipFilePath!) {
    createDownloadZipFilePath(input: $input)
  }
`;
export const createOfficeInfo = /* GraphQL */ `
  mutation CreateOfficeInfo(
    $input: CreateOfficeInfoInput!
    $condition: ModelOfficeInfoConditionInput
  ) {
    createOfficeInfo(input: $input, condition: $condition) {
      serialNumber
      label
      pressType
      uploadCurve
      accessGroups
      iotName
      clientIp
      power
      boxIp
      remoteAccess
      enableTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateOfficeInfo = /* GraphQL */ `
  mutation UpdateOfficeInfo(
    $input: UpdateOfficeInfoInput!
    $condition: ModelOfficeInfoConditionInput
  ) {
    updateOfficeInfo(input: $input, condition: $condition) {
      serialNumber
      label
      pressType
      uploadCurve
      accessGroups
      iotName
      clientIp
      power
      boxIp
      remoteAccess
      enableTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteOfficeInfo = /* GraphQL */ `
  mutation DeleteOfficeInfo(
    $input: DeleteOfficeInfoInput!
    $condition: ModelOfficeInfoConditionInput
  ) {
    deleteOfficeInfo(input: $input, condition: $condition) {
      serialNumber
      label
      pressType
      uploadCurve
      accessGroups
      iotName
      clientIp
      power
      boxIp
      remoteAccess
      enableTime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createReferenceLine = /* GraphQL */ `
  mutation CreateReferenceLine(
    $input: CreateReferenceLineInput!
    $condition: ModelReferenceLineConditionInput
  ) {
    createReferenceLine(input: $input, condition: $condition) {
      serialNumber
      type
      name
      value
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateReferenceLine = /* GraphQL */ `
  mutation UpdateReferenceLine(
    $input: UpdateReferenceLineInput!
    $condition: ModelReferenceLineConditionInput
  ) {
    updateReferenceLine(input: $input, condition: $condition) {
      serialNumber
      type
      name
      value
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteReferenceLine = /* GraphQL */ `
  mutation DeleteReferenceLine(
    $input: DeleteReferenceLineInput!
    $condition: ModelReferenceLineConditionInput
  ) {
    deleteReferenceLine(input: $input, condition: $condition) {
      serialNumber
      type
      name
      value
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLoadDataEachProductDaily = /* GraphQL */ `
  mutation CreateLoadDataEachProductDaily(
    $input: CreateLoadDataEachProductDailyInput!
    $condition: ModelLoadDataEachProductDailyConditionInput
  ) {
    createLoadDataEachProductDaily(input: $input, condition: $condition) {
      office
      date
      productId
      dataCount
      eccentricityX
      eccentricityY
      totalLoad
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLoadDataEachProductDaily = /* GraphQL */ `
  mutation UpdateLoadDataEachProductDaily(
    $input: UpdateLoadDataEachProductDailyInput!
    $condition: ModelLoadDataEachProductDailyConditionInput
  ) {
    updateLoadDataEachProductDaily(input: $input, condition: $condition) {
      office
      date
      productId
      dataCount
      eccentricityX
      eccentricityY
      totalLoad
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLoadDataEachProductDaily = /* GraphQL */ `
  mutation DeleteLoadDataEachProductDaily(
    $input: DeleteLoadDataEachProductDailyInput!
    $condition: ModelLoadDataEachProductDailyConditionInput
  ) {
    deleteLoadDataEachProductDaily(input: $input, condition: $condition) {
      office
      date
      productId
      dataCount
      eccentricityX
      eccentricityY
      totalLoad
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLoadDataEachProductLastMonth = /* GraphQL */ `
  mutation CreateLoadDataEachProductLastMonth(
    $input: CreateLoadDataEachProductLastMonthInput!
    $condition: ModelLoadDataEachProductLastMonthConditionInput
  ) {
    createLoadDataEachProductLastMonth(input: $input, condition: $condition) {
      office
      date
      productId
      dataCount
      eccentricityX
      eccentricityY
      totalLoad
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLoadDataEachProductLastMonth = /* GraphQL */ `
  mutation UpdateLoadDataEachProductLastMonth(
    $input: UpdateLoadDataEachProductLastMonthInput!
    $condition: ModelLoadDataEachProductLastMonthConditionInput
  ) {
    updateLoadDataEachProductLastMonth(input: $input, condition: $condition) {
      office
      date
      productId
      dataCount
      eccentricityX
      eccentricityY
      totalLoad
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLoadDataEachProductLastMonth = /* GraphQL */ `
  mutation DeleteLoadDataEachProductLastMonth(
    $input: DeleteLoadDataEachProductLastMonthInput!
    $condition: ModelLoadDataEachProductLastMonthConditionInput
  ) {
    deleteLoadDataEachProductLastMonth(input: $input, condition: $condition) {
      office
      date
      productId
      dataCount
      eccentricityX
      eccentricityY
      totalLoad
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLoadDataEachShotDaily = /* GraphQL */ `
  mutation CreateLoadDataEachShotDaily(
    $input: CreateLoadDataEachShotDailyInput!
    $condition: ModelLoadDataEachShotDailyConditionInput
  ) {
    createLoadDataEachShotDaily(input: $input, condition: $condition) {
      office
      date
      type
      loadDistributionData
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLoadDataEachShotDaily = /* GraphQL */ `
  mutation UpdateLoadDataEachShotDaily(
    $input: UpdateLoadDataEachShotDailyInput!
    $condition: ModelLoadDataEachShotDailyConditionInput
  ) {
    updateLoadDataEachShotDaily(input: $input, condition: $condition) {
      office
      date
      type
      loadDistributionData
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLoadDataEachShotDaily = /* GraphQL */ `
  mutation DeleteLoadDataEachShotDaily(
    $input: DeleteLoadDataEachShotDailyInput!
    $condition: ModelLoadDataEachShotDailyConditionInput
  ) {
    deleteLoadDataEachShotDaily(input: $input, condition: $condition) {
      office
      date
      type
      loadDistributionData
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLoadDataEachShotLastMonth = /* GraphQL */ `
  mutation CreateLoadDataEachShotLastMonth(
    $input: CreateLoadDataEachShotLastMonthInput!
    $condition: ModelLoadDataEachShotLastMonthConditionInput
  ) {
    createLoadDataEachShotLastMonth(input: $input, condition: $condition) {
      office
      date
      type
      loadDistributionData
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLoadDataEachShotLastMonth = /* GraphQL */ `
  mutation UpdateLoadDataEachShotLastMonth(
    $input: UpdateLoadDataEachShotLastMonthInput!
    $condition: ModelLoadDataEachShotLastMonthConditionInput
  ) {
    updateLoadDataEachShotLastMonth(input: $input, condition: $condition) {
      office
      date
      type
      loadDistributionData
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLoadDataEachShotLastMonth = /* GraphQL */ `
  mutation DeleteLoadDataEachShotLastMonth(
    $input: DeleteLoadDataEachShotLastMonthInput!
    $condition: ModelLoadDataEachShotLastMonthConditionInput
  ) {
    deleteLoadDataEachShotLastMonth(input: $input, condition: $condition) {
      office
      date
      type
      loadDistributionData
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDiagnosticChartDataDaily = /* GraphQL */ `
  mutation CreateDiagnosticChartDataDaily(
    $input: CreateDiagnosticChartDataDailyInput!
    $condition: ModelDiagnosticChartDataDailyConditionInput
  ) {
    createDiagnosticChartDataDaily(input: $input, condition: $condition) {
      office
      date
      createdDay
      companyName
      workNumber
      model
      useYears
      modelNumber
      dueDate
      creationResult
      shotCount {
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      dieHeightRange {
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      dieHeightCount {
        rise {
          value
          judge
          __typename
        }
        descent {
          value
          judge
          __typename
        }
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      clutchTime {
        start {
          value
          judge
          __typename
        }
        link {
          value
          judge
          __typename
        }
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      brakeTime {
        start {
          value
          judge
          __typename
        }
        brake {
          value
          judge
          __typename
        }
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      pointLeak {
        leftFront {
          value
          judge
          __typename
        }
        leftRear {
          value
          judge
          __typename
        }
        rightFront {
          value
          judge
          __typename
        }
        rightRear {
          value
          judge
          __typename
        }
        note
        __typename
      }
      cfErrorTemp {
        rollFeeder {
          value
          judge
          diff
          __typename
        }
        terminalFeeder {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      cfErrorElect {
        rollFeeder {
          value
          judge
          diff
          __typename
        }
        terminalFeeder {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      plErrorTemp {
        blank {
          value
          judge
          diff
          __typename
        }
        piler {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      plErrorElect {
        blank {
          value
          judge
          diff
          __typename
        }
        piler {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      coilRange {
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      rbMalfunction {
        df {
          value
          judge
          diff
          __typename
        }
        ld {
          value
          judge
          diff
          __typename
        }
        no1 {
          value
          judge
          diff
          __typename
        }
        no2 {
          value
          judge
          diff
          __typename
        }
        no3 {
          value
          judge
          diff
          __typename
        }
        ul {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      trErrorTemp {
        frontAmp {
          value
          judge
          diff
          __typename
        }
        frontLinear1 {
          value
          judge
          diff
          __typename
        }
        frontLinear2 {
          value
          judge
          diff
          __typename
        }
        rearAmp {
          value
          judge
          diff
          __typename
        }
        rearLinear1 {
          value
          judge
          diff
          __typename
        }
        rearLinear2 {
          value
          judge
          diff
          __typename
        }
        leftLift {
          value
          judge
          diff
          __typename
        }
        rightLift {
          value
          judge
          diff
          __typename
        }
        leftClamp {
          value
          judge
          diff
          __typename
        }
        rightClamp {
          value
          judge
          diff
          __typename
        }
        addAxis {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      trErrorPosi {
        frontFeed {
          value
          judge
          diff
          __typename
        }
        rearFeed {
          value
          judge
          diff
          __typename
        }
        leftLift {
          value
          judge
          diff
          __typename
        }
        rightLift {
          value
          judge
          diff
          __typename
        }
        leftClamp {
          value
          judge
          diff
          __typename
        }
        rightClamp {
          value
          judge
          diff
          __typename
        }
        addAxis {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      trErrorElect {
        frontFeed {
          value
          judge
          diff
          __typename
        }
        rearFeed {
          value
          judge
          diff
          __typename
        }
        leftLift {
          value
          judge
          diff
          __typename
        }
        rightLift {
          value
          judge
          diff
          __typename
        }
        leftClamp {
          value
          judge
          diff
          __typename
        }
        rightClamp {
          value
          judge
          diff
          __typename
        }
        addAxis {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      microInching {
        total {
          value
          judge
          __typename
        }
        magnet {
          value
          judge
          __typename
        }
        note
        __typename
      }
      other
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDiagnosticChartDataDaily = /* GraphQL */ `
  mutation UpdateDiagnosticChartDataDaily(
    $input: UpdateDiagnosticChartDataDailyInput!
    $condition: ModelDiagnosticChartDataDailyConditionInput
  ) {
    updateDiagnosticChartDataDaily(input: $input, condition: $condition) {
      office
      date
      createdDay
      companyName
      workNumber
      model
      useYears
      modelNumber
      dueDate
      creationResult
      shotCount {
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      dieHeightRange {
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      dieHeightCount {
        rise {
          value
          judge
          __typename
        }
        descent {
          value
          judge
          __typename
        }
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      clutchTime {
        start {
          value
          judge
          __typename
        }
        link {
          value
          judge
          __typename
        }
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      brakeTime {
        start {
          value
          judge
          __typename
        }
        brake {
          value
          judge
          __typename
        }
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      pointLeak {
        leftFront {
          value
          judge
          __typename
        }
        leftRear {
          value
          judge
          __typename
        }
        rightFront {
          value
          judge
          __typename
        }
        rightRear {
          value
          judge
          __typename
        }
        note
        __typename
      }
      cfErrorTemp {
        rollFeeder {
          value
          judge
          diff
          __typename
        }
        terminalFeeder {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      cfErrorElect {
        rollFeeder {
          value
          judge
          diff
          __typename
        }
        terminalFeeder {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      plErrorTemp {
        blank {
          value
          judge
          diff
          __typename
        }
        piler {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      plErrorElect {
        blank {
          value
          judge
          diff
          __typename
        }
        piler {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      coilRange {
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      rbMalfunction {
        df {
          value
          judge
          diff
          __typename
        }
        ld {
          value
          judge
          diff
          __typename
        }
        no1 {
          value
          judge
          diff
          __typename
        }
        no2 {
          value
          judge
          diff
          __typename
        }
        no3 {
          value
          judge
          diff
          __typename
        }
        ul {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      trErrorTemp {
        frontAmp {
          value
          judge
          diff
          __typename
        }
        frontLinear1 {
          value
          judge
          diff
          __typename
        }
        frontLinear2 {
          value
          judge
          diff
          __typename
        }
        rearAmp {
          value
          judge
          diff
          __typename
        }
        rearLinear1 {
          value
          judge
          diff
          __typename
        }
        rearLinear2 {
          value
          judge
          diff
          __typename
        }
        leftLift {
          value
          judge
          diff
          __typename
        }
        rightLift {
          value
          judge
          diff
          __typename
        }
        leftClamp {
          value
          judge
          diff
          __typename
        }
        rightClamp {
          value
          judge
          diff
          __typename
        }
        addAxis {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      trErrorPosi {
        frontFeed {
          value
          judge
          diff
          __typename
        }
        rearFeed {
          value
          judge
          diff
          __typename
        }
        leftLift {
          value
          judge
          diff
          __typename
        }
        rightLift {
          value
          judge
          diff
          __typename
        }
        leftClamp {
          value
          judge
          diff
          __typename
        }
        rightClamp {
          value
          judge
          diff
          __typename
        }
        addAxis {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      trErrorElect {
        frontFeed {
          value
          judge
          diff
          __typename
        }
        rearFeed {
          value
          judge
          diff
          __typename
        }
        leftLift {
          value
          judge
          diff
          __typename
        }
        rightLift {
          value
          judge
          diff
          __typename
        }
        leftClamp {
          value
          judge
          diff
          __typename
        }
        rightClamp {
          value
          judge
          diff
          __typename
        }
        addAxis {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      microInching {
        total {
          value
          judge
          __typename
        }
        magnet {
          value
          judge
          __typename
        }
        note
        __typename
      }
      other
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDiagnosticChartDataDaily = /* GraphQL */ `
  mutation DeleteDiagnosticChartDataDaily(
    $input: DeleteDiagnosticChartDataDailyInput!
    $condition: ModelDiagnosticChartDataDailyConditionInput
  ) {
    deleteDiagnosticChartDataDaily(input: $input, condition: $condition) {
      office
      date
      createdDay
      companyName
      workNumber
      model
      useYears
      modelNumber
      dueDate
      creationResult
      shotCount {
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      dieHeightRange {
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      dieHeightCount {
        rise {
          value
          judge
          __typename
        }
        descent {
          value
          judge
          __typename
        }
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      clutchTime {
        start {
          value
          judge
          __typename
        }
        link {
          value
          judge
          __typename
        }
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      brakeTime {
        start {
          value
          judge
          __typename
        }
        brake {
          value
          judge
          __typename
        }
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      pointLeak {
        leftFront {
          value
          judge
          __typename
        }
        leftRear {
          value
          judge
          __typename
        }
        rightFront {
          value
          judge
          __typename
        }
        rightRear {
          value
          judge
          __typename
        }
        note
        __typename
      }
      cfErrorTemp {
        rollFeeder {
          value
          judge
          diff
          __typename
        }
        terminalFeeder {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      cfErrorElect {
        rollFeeder {
          value
          judge
          diff
          __typename
        }
        terminalFeeder {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      plErrorTemp {
        blank {
          value
          judge
          diff
          __typename
        }
        piler {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      plErrorElect {
        blank {
          value
          judge
          diff
          __typename
        }
        piler {
          value
          judge
          diff
          __typename
        }
        other {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      coilRange {
        total {
          value
          judge
          __typename
        }
        note
        __typename
      }
      rbMalfunction {
        df {
          value
          judge
          diff
          __typename
        }
        ld {
          value
          judge
          diff
          __typename
        }
        no1 {
          value
          judge
          diff
          __typename
        }
        no2 {
          value
          judge
          diff
          __typename
        }
        no3 {
          value
          judge
          diff
          __typename
        }
        ul {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      trErrorTemp {
        frontAmp {
          value
          judge
          diff
          __typename
        }
        frontLinear1 {
          value
          judge
          diff
          __typename
        }
        frontLinear2 {
          value
          judge
          diff
          __typename
        }
        rearAmp {
          value
          judge
          diff
          __typename
        }
        rearLinear1 {
          value
          judge
          diff
          __typename
        }
        rearLinear2 {
          value
          judge
          diff
          __typename
        }
        leftLift {
          value
          judge
          diff
          __typename
        }
        rightLift {
          value
          judge
          diff
          __typename
        }
        leftClamp {
          value
          judge
          diff
          __typename
        }
        rightClamp {
          value
          judge
          diff
          __typename
        }
        addAxis {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      trErrorPosi {
        frontFeed {
          value
          judge
          diff
          __typename
        }
        rearFeed {
          value
          judge
          diff
          __typename
        }
        leftLift {
          value
          judge
          diff
          __typename
        }
        rightLift {
          value
          judge
          diff
          __typename
        }
        leftClamp {
          value
          judge
          diff
          __typename
        }
        rightClamp {
          value
          judge
          diff
          __typename
        }
        addAxis {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      trErrorElect {
        frontFeed {
          value
          judge
          diff
          __typename
        }
        rearFeed {
          value
          judge
          diff
          __typename
        }
        leftLift {
          value
          judge
          diff
          __typename
        }
        rightLift {
          value
          judge
          diff
          __typename
        }
        leftClamp {
          value
          judge
          diff
          __typename
        }
        rightClamp {
          value
          judge
          diff
          __typename
        }
        addAxis {
          value
          judge
          diff
          __typename
        }
        note
        __typename
      }
      microInching {
        total {
          value
          judge
          __typename
        }
        magnet {
          value
          judge
          __typename
        }
        note
        __typename
      }
      other
      accessGroups
      createdAt
      updatedAt
      __typename
    }
  }
`;
